<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
  <path fill="#000" d="M14 5.496h-4c0-1.5.5-2.5 2-2.5s2 1 2 2.5zM10 20.996h4c0 1.5-.5 2.5-2 2.5s-2-1-2-2.5z"/>
  <path stroke="#000" d="M4.5 17.496v-7c0-1.713 1.068-3.099 2.5-4.035a9.107 9.107 0 014.9-1.465c1.715 0 3.67.53 5.1 1.465 1.432.936 2.5 2.322 2.5 4.035v7M5 17.496c-1.38 0-2.5.62-2.5 2s1.12 2 2.5 2h14c1.38 0 2.5-.62 2.5-2s-1.12-2-2.5-2H5z"/>
</svg>
